<template>
 <div class="fc-page mg-page rp-page rp-edu_dashbord">
  <nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb" /></nav>
  <header class="fc-heading"><div><h1>教务数据报表</h1><p>对比学员应到与实到情况，了解教学出勤趋势</p></div><span class="rp-heading-symbol" aria-hidden="true"><v-icon size="25" color="#d9363e">mdi-chart-box-outline</v-icon></span></header>
  <section class="fc-filters rp-year-filters" aria-label="统计年份筛选"><div class="fc-filter-heading"><h3>统计范围</h3><span>选择年份后查询</span></div><form class="rp-year-form" @submit.prevent="getEduCameClassChartData"><div class="fc-filter-cell"><v-select :items="yearItems" v-model="query.year" item-text="name" item-value="value" label="年份" dense outlined hide-details color="#d9363e" /></div><v-btn type="submit" depressed color="#d9363e" dark><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></form></section>
  <div class="rp-chart-grid">
   <article class="rp-chart rp-chart-full"><div class="rp-chart-heading"><div><h3>学员应到 / 实到统计</h3><p>按月对比应到与实际出勤人数</p></div></div><div class="rp-chart-body"><ve-histogram v-if="chartData1.rows.length" :data="chartData1" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="460px" :extend="Object.assign({}, chartExtend1, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" ref="chart1" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div></article>
  </div>
 </div>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "edu-dashboard-index",
		data() {
			this.chartExtend1 = {
			  title: {
				text: '学员应到/实到统计'
			  },
			  series: {
				barWidth: 40,
				label:{show:true,position:'top'}
			  }
			}
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/home/index"
					},
					{
						text: '数据报表',
						disabled: true
					},
					{
						text: '教务数据报表',
						disabled: true
					},
				],
				tab:null,
				shopId:"",
				yearItems:[],
				query: {
					year:""+new Date().getFullYear()
				},
				chartData1: {
					columns: ['月份', '应到人数','实到人数'],
					rows: [],
				},
				
				
			}
		},
		mounted() {
			this.generateYearItems();
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.getEduCameClassChartData();
		},
		methods: {
			generateYearItems(){
				let fromYear = 2018;
				const now = new Date();
				const nowYear = now.getFullYear();
				
				for (let i = fromYear; i <= nowYear; i++) {
					this.yearItems.push({value:i.toString(),name:i.toString()+"年"})
				}
			},
			getEduCameClassChartData() {
			
				const that = this;
			
				let url = `/report/edu/came/class/dashboard/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
				
					if (response.data["code"] === 200) {
						
						console.log(response.data["data"]);
						
						that.chartData1.columns = response.data["data"]["labels"] ? response.data["data"]["labels"] : [];
						that.chartData1.rows = response.data["data"]["dataList"]? response.data["data"]["dataList"] : [];
						that.summaryText  =  response.data["data"]["summaryText"];
						
						return
					}
			
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/reports-management.scss";
</style>
